
export type Theme = 'light' | 'dark';
export type Density = 'compact' | 'regular' | 'spacious';

export const THEME_KEY = 'vp-theme';
export const DENSITY_KEY = 'vp-density';

function readAttribute(): Theme {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

export function currentTheme(): Theme {
  return readAttribute();
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch (error) {
    console.warn('Тема не сохранена: localStorage недоступен', error);
  }
}

export function applyDensity(density: Density): void {
  document.documentElement.setAttribute('data-density', density);
  try {
    localStorage.setItem(DENSITY_KEY, density);
  } catch (error) {
    console.warn('Плотность не сохранена: localStorage недоступен', error);
  }
}
